import type { ApiResponse, NavigationOption } from '@packages/shared-types';

import { apiClient } from '@/services/apiClient';

export interface CreateNavigationOptionPayload {
  name: string;
  i18nKey: string;
  icon: string;
  route: string;
  isDefault?: boolean;
}

export interface UpdateNavigationOptionPayload {
  name?: string;
  i18nKey?: string;
  icon?: string;
  route?: string;
  isDefault?: boolean;
}

export async function getNavigationOptions(
  route?: string,
): Promise<NavigationOption[]> {
  const params = route ? { route } : {};
  const response = await apiClient.get<ApiResponse<NavigationOption[]>>(
    '/api/navigation-options',
    { params },
  );
  return response.data.data;
}

export async function getNavigationOptionById(
  id: string,
): Promise<NavigationOption> {
  const response = await apiClient.get<ApiResponse<NavigationOption>>(
    `/api/navigation-options/${id}`,
  );
  return response.data.data;
}

export async function createNavigationOption(
  payload: CreateNavigationOptionPayload,
): Promise<NavigationOption> {
  const response = await apiClient.post<ApiResponse<NavigationOption>>(
    '/api/navigation-options',
    payload,
  );
  return response.data.data;
}

export async function updateNavigationOption(
  id: string,
  payload: UpdateNavigationOptionPayload,
): Promise<NavigationOption> {
  const response = await apiClient.put<ApiResponse<NavigationOption>>(
    `/api/navigation-options/${id}`,
    payload,
  );
  return response.data.data;
}

export async function deleteNavigationOption(id: string): Promise<void> {
  await apiClient.delete(`/api/navigation-options/${id}`);
}
